import paddyOperation from "../Images/client/field/paddy-operation.jpg";
import womanOperatingWeeder from "../Images/client/field/woman-operating-weeder.jpg";
import ashwiniWithMachines from "../Images/client/field/ashwini-with-machines.jpg";
import sw4Photo from "../Images/client/field/sw4.jpeg";
import farmerPaddyDemo from "../Images/client/field/farmer-paddy-demo.jpg";
import farmerPlantationDemo from "../Images/client/field/farmer-plantation-demo.jpg";
import paddyRowDemo1 from "../Images/client/field/paddy-row-demo-1.jpg";
import paddyRowDemo2 from "../Images/client/field/paddy-row-demo-2.jpg";
import singleWheelFieldDemo from "../Images/client/field/single-wheel-field-demo.jpg";
import singleWheelField1 from "../Images/client/products/single-wheel-field-1.jpg";
import singleWheelField2 from "../Images/client/products/single-wheel-field-2.jpeg";
import singleWheelField3 from "../Images/client/products/single-wheel-field-3.jpeg";
import poultryField1 from "../Images/client/products/poultry-raker-field-1.jpeg";
import poultryField2 from "../Images/client/products/poultry-raker-field-2.jpg";
import trolleyField1 from "../Images/client/products/trolley-brush-cutter-field-1.jpg";
import trolleyField2 from "../Images/client/products/trolley-brush-cutter-field-2.jpeg";
import engineeringMinds from "../Images/client/media/news/engineering-minds.jpeg";
import krishiMelaGkvk from "../Images/client/media/news/krishi-mela-gkvk.jpeg";
import catalogCover from "../Images/client/media/catalog/sna-product-catalog-2026-cover.png";
import octoberKrishimela from "../Images/client/media/events/october-2025-krishimela.jpg";
import novemberGkvk from "../Images/client/media/events/november-2025-gkvk-krishimela.jpg";
import decemberMandya from "../Images/client/media/events/december-2025-mandya-krishimela.jpg";
import februaryKisan from "../Images/client/media/events/february-march-2026-kisan-swaraj.jpg";

export const galleryPhotos = [
  {
    id: "paddy-operation",
    src: paddyOperation,
    title: "Paddy field operation",
    caption: "Battery-powered equipment operating in paddy field conditions.",
    alt: "Two farmers operating a weeding machine between paddy rows in a flooded field.",
    span: "md:sn-row-span-2",
  },
  {
    id: "woman-operating-weeder",
    src: womanOperatingWeeder,
    title: "Field weeding demonstration",
    caption: "A woman guides Suryanirbhar equipment through cultivated soil.",
    alt: "Woman guiding a weeding machine through a cultivated field.",
  },
  {
    id: "single-wheel-field",
    src: singleWheelField1,
    title: "Single wheel weeder in use",
    caption: "Field-use photograph from the client SNB asset library.",
    alt: "Person using a single wheel weeder between crop rows.",
  },
  {
    id: "single-wheel-row",
    src: singleWheelField2,
    title: "Inter-row weeding",
    caption: "Machine use in a row-crop field.",
    alt: "Single wheel weeder being used in a row-crop field.",
  },
  {
    id: "single-wheel-demo",
    src: singleWheelField3,
    title: "Field equipment demonstration",
    caption: "Battery-operated field equipment demonstrated outdoors.",
    alt: "Person demonstrating a weeding machine in an agricultural field.",
    span: "md:sn-col-span-2",
  },
  {
    id: "poultry-raking",
    src: poultryField1,
    title: "Poultry raking machine",
    caption: "Real-use poultry raking machine photograph from the client asset library.",
    alt: "Poultry raking machine inside a poultry shed.",
  },
  {
    id: "poultry-raking-shed",
    src: poultryField2,
    title: "Poultry shed operation",
    caption: "Poultry raking equipment shown in shed conditions.",
    alt: "People standing near a poultry raking machine inside a poultry shed.",
  },
  {
    id: "brush-cutter-demo",
    src: trolleyField1,
    title: "Brush cutter demonstration",
    caption: "Trolley brush cutter photographed during a field demonstration.",
    alt: "People demonstrating a trolley brush cutter in a grassy field.",
  },
  {
    id: "brush-cutter-field",
    src: trolleyField2,
    title: "Brush cutter in field conditions",
    caption: "Brush cutting equipment shown in field use.",
    alt: "Person operating a trolley brush cutter in an agricultural field.",
  },
  {
    id: "machine-display",
    src: ashwiniWithMachines,
    title: "Equipment in field context",
    caption: "Client-provided image showing agricultural machines in a cultivated field.",
    alt: "Person standing beside two agricultural machines in a cultivated field.",
  },
  {
    id: "sw4-client-field",
    src: sw4Photo,
    title: "Single wheel weeder field use",
    caption: "Client-requested SW4.jpeg field photograph from the supplied article photo set.",
    alt: "Single Wheel Weeder being used in a crop field.",
  },
  {
    id: "farmer-paddy-demo",
    src: farmerPaddyDemo,
    title: "Paddy field demonstration",
    caption: "Client-supplied field photograph showing machine use in paddy conditions.",
    alt: "Farmer guiding a machine in a paddy field.",
  },
  {
    id: "farmer-plantation-demo",
    src: farmerPlantationDemo,
    title: "Plantation field use",
    caption: "Client-supplied photograph showing equipment use in a plantation setting.",
    alt: "Farmer operating equipment in a plantation field.",
  },
  {
    id: "paddy-row-demo-one",
    src: paddyRowDemo1,
    title: "Paddy row operation",
    caption: "Client-supplied field photograph from the paddy work photo set.",
    alt: "Machine being used between rows in a paddy field.",
  },
  {
    id: "paddy-row-demo-two",
    src: paddyRowDemo2,
    title: "Paddy weeding in field",
    caption: "Client-supplied field photograph showing paddy equipment in use.",
    alt: "Two people operating a paddy weeding machine in a flooded field.",
    span: "md:sn-col-span-2",
  },
  {
    id: "single-wheel-field-demo",
    src: singleWheelFieldDemo,
    title: "Single wheel field demonstration",
    caption: "Client-supplied field photograph showing a single wheel weeder in cultivated rows.",
    alt: "Person using a single wheel weeder in a crop field.",
  },
];

export const mediaVideos = [
  { id: "3-QyY33c-Ic", title: "Single Wheel Weeder", heading: "Single Wheel Weeder" },
  { id: "oRZ_8-8BeDY", title: "Electric Cono Weeder", heading: "Electric Cono Weeder" },
  { id: "whubCxXBEQk", title: "Poultry Raking Machine", heading: "Poultry Raking Machine" },
  { id: "44khpJEHba8", title: "Trolley Brush Cutter", heading: "Trolley Brush Cutter" },
  { id: "PZVKshjESgk", title: "Suryanirbhar field demonstration", heading: "Suryanirbhar field demonstration" },
  { id: "Rat-pH7Ku2Q", title: "Single Wheel Weeder field video", heading: "Single Wheel Weeder field video" },
  { id: "4zGTpkQTdhQ", title: "Poultry Raking Machine field video", heading: "Poultry Raking Machine field video" },
  { id: "2em6t0-Uu2k", title: "Suryanirbhar machine demonstration", heading: "Suryanirbhar machine demonstration" },
];

export const newsItems = [
  {
    id: "engineering-minds",
    src: engineeringMinds,
    title: "Engineering Minds feature",
    caption: "Press clipping about Suryanirbhar Agritech and farming-focused engineering.",
    alt: "Press clipping titled Engineering Minds featuring Suryanirbhar Agritech.",
    source: "SNB /Photos/News/Engineers day.jpeg",
  },
  {
    id: "krishi-mela-gkvk",
    src: krishiMelaGkvk,
    title: "Krishi Mela press clipping",
    caption: "Press clipping about Krishi Mela and technology-driven agricultural growth.",
    alt: "Newspaper clipping about Krishi Mela with agricultural machinery photographs.",
    source: "SNB /Photos/News/KM GKVK.jpeg",
  },
];

export const eventStories = [
  {
    id: "october-krishimela",
    title: "Krishimela demonstrations across Karnataka",
    meta: "October 2025 newsletter",
    src: octoberKrishimela,
    alt: "Newsletter page about Krishimela activity and field demonstrations in October 2025.",
    description: "The October 2025 newsletter reports Krishimela activity across Karnataka, including Dharwad and Bramhavara, where people were introduced to the Weeding as a Service model.",
    source: "SNB Newsletter - October 2025, page 1",
    derived: true,
  },
  {
    id: "november-gkvk",
    title: "GKVK Krishi Mela 2025",
    meta: "November 2025 newsletter",
    src: novemberGkvk,
    alt: "Newsletter page describing Suryanirbhar participation in GKVK Krishi Mela 2025.",
    description: "The November 2025 newsletter states that Suryanirbhar exhibited at GKVK Krishi Mela at UAS Bengaluru and received farmer interest in electric weeders and poultry raking machines.",
    source: "SNB Newsletter - November 2025, page 3",
    derived: true,
  },
  {
    id: "december-mandya",
    title: "Mandya Krishi Mela at VC Farm",
    meta: "December 2025 newsletter",
    src: decemberMandya,
    alt: "Newsletter page about participation in Mandya Krishi Mela at VC Farm.",
    description: "The December 2025 newsletter reports Suryanirbhar's participation at VC Farm, Mandya Krishi Mela, including paddy equipment demos with support from Puttannaiah Foundation.",
    source: "SNB Newsletter - December 2025, page 3",
    derived: true,
  },
  {
    id: "kisan-swaraj",
    title: "Kisan Swaraj Sammelan, Mysore",
    meta: "February/March 2026 newsletter",
    src: februaryKisan,
    alt: "Newsletter page about Kisan Swaraj Sammelan, Mysore and Rainmatter Climate Founders Day.",
    description: "The February/March 2026 newsletter reports Suryanirbhar participation at Kisan Swaraj Sammelan in Mysore, with farmers, FPOs, NGOs and companies expressing interest in collaboration.",
    source: "SNB Newsletter - February/March 2026, page 3",
    derived: true,
  },
];

export const catalogs = [
  {
    title: "SNA Product Catalog 2026",
    caption: "Suryanirbhar Agritech product catalog.",
    file: "/ProductCatalog/catalog.pdf",
    fileName: "SNA Product Catalog 2026.pdf",
    cover: catalogCover,
    source: "SNB /Catalog/SNA Product Catalog.pdf and existing public/ProductCatalog/catalog.pdf are byte-identical.",
  },
];
